import React from "react"

import * as styles from "../Styles/Summary.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import TrafficLightWidget from "../../TrafficLightWidget"

import { CrowdLamp } from "../../../types/place"
interface LampProps {
  lamp: CrowdLamp
}

const Lamp: React.FC<LampProps> = (props) => {
  return (
    <React.Fragment>
      {props.lamp && (
        <div className={styles.lampSection}>
          <TrafficLightWidget currentColor={props.lamp.color} width={61} />
          <span className={cn("lampMessage", `lamp--${props.lamp.color}`)}>
            {props.lamp.message}
          </span>
          {props.lamp.available && (
            <span className={styles.annotation}>{props.lamp.description}</span>
          )}
        </div>
      )}
    </React.Fragment>
  )
}
export default Lamp
